import {
	Component,
	Inject,
	Input,
	Optional,
	OnInit,
	Output,
	EventEmitter,
} from "@angular/core";
import { FormGroupDirective } from "@angular/forms";
import { takeUntil } from "rxjs/operators";
import { FormFieldDirective } from "../form-field";
import { FormFieldType } from "../form-field.model";

@Component({
    selector: "tc-autocomplete-field",
    templateUrl: "./autocomplete-field.component.html",
    styleUrls: ["./autocomplete-field.component.scss"],
    standalone: false
})
export class AutoCompleteFieldComponent
	extends FormFieldDirective
	implements OnInit {
	public showOptions: boolean;
	public optionExists: boolean;
	public filteredOptions: any[];
	public options: any[];
	@Input() scroll: boolean;
	@Input() selfFilter: boolean;
	@Input() displayOption: string;
	@Input() set setOptions(options: any[]) {
		this.options = options;
		this.filteredOptions = options;
	}
	@Output() selection = new EventEmitter<any>();

	constructor(
		@Optional()
		@Inject(FormGroupDirective)
		formGroupDirective: FormGroupDirective
	) {
		super(formGroupDirective);
	}

	ngOnInit(): void {
		this.type = FormFieldType.INPUT;
		this.control.valueChanges
			.pipe(takeUntil(this.unsubscribeAll))
			.subscribe((val) => {
				if (this.selfFilter) {
					this.filteredOptions = this.filter(val);
				}
			});
	}

	public filter(val: string): any[] {
		return this.options?.filter((option) =>
			option.Value.toLowerCase().includes(val.toLowerCase())
		);
	}

	public optionSelected(option: any): void {
		this.optionExists = true;
		this.showOptions = false;
		this.selection.emit(option);
		if (option.Value) {
			this.control.setValue(option.Value);
		}
	}

	public displayValue(option: any): string {
		if (this.displayOption === "Suburb") {
			return (
				option.Suburb + " (" + option.Postcode + ") | " + option.State
			);
		}
		return option.Value;
	}

	clickOutside(event) {
		this.showOptions = false;
	}
}
